module.exports = __webpack_public_path__ + "4-filled-e24f74d31242b04eda4c6e9fdefc514c.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/filled/4-filled.svg
// module id = 113
// module chunks = 0